import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@fantaz/shared/ui/material';

import {
  errorTailorImports,
  provideErrorTailorConfig,
} from '@ngneat/error-tailor';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { AlertModule } from '@fantaz/ui';
import { FormControlErrorComponent } from './core/error-form-field-error/form-field-error.component';
import { FullWidthDirective } from './directives/full-width.directive';
import { FormFieldAddressComponent } from './form-fields/address-field-input/address-field-input.component';
import { SmartyAutocompleteComponent } from './form-fields/address-field-input/variants/smarty/smarty-autocomplete.component';
import { FormFieldDateComponent } from './form-fields/form-field-date/date-field-input.component';
import { FormFieldTextComponent } from './form-fields/form-field-text/form-field-text.component';
import { HighlightPipe } from './pipes/highlight.pipe';

const components = [
  SmartyAutocompleteComponent,
  FormFieldAddressComponent,
  FormFieldDateComponent,
  FormFieldTextComponent,
  FullWidthDirective,
  HighlightPipe,
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    errorTailorImports,
    NgxMaskDirective,
    NgxMaskPipe,
    AlertModule,
  ],
  providers: [
    provideNgxMask({
      validation: true,
    }),
    //
    // This is a global configuration for all form fields
    //

    provideErrorTailorConfig({
      errors: {
        useValue: {
          // TODO: Add global error messages for all form fields
          required: 'This field is required',
          minlength: ({ requiredLength, actualLength }) =>
            `Expect ${requiredLength} but got ${actualLength}`,
          invalidAddress: (error) => {
            return `We could not validate this address. Please double check this is written like what you see on your driver license or <a class="text-underline">switch to address form</a>.`;
          },
          ageUnder18: `Age is under 18`,
          age: `Invalid date of birth`,
          pattern: `Format incorrect`,
          mask: `Invalid value`,
          empty: `This field is required`,
          requiredFirstName: `First Name is required.`,
          requiredLastName: `Last Name is required.`,
          requiredCreditCard: `Card number can't be empty.`,
          requiredBusinessName: `Business name is required.`,
          requiredStateOfFormation: '',
          requiredFederalTaxClassification: `Federal Tax Classification is required`,
          blockedStateStateOfFormation: ` Unfortunately cash play is unavailable in this State of Formation.`,
          expired: `Card expired. Please use a valid one.`,
          invalidExpirationDate: `Invalid expiration date.`,
          ssn: `Invalid SSN`,
          lastSsnDigits: `Invalid last 4 SSN digits`,
          nineDigits: `SSN should be nine digits long`,
          invalidCreditCard: 'Invalid card number.',
          disabledCardType: ({ detected }: { detected: string }) =>
            `Please use a different credit card, we can't process ${detected} credit cards at this moment.`,
          invalidAccountNumber: 'Invalid account number.',
          requiredAccountNumber: `Account number can't be empty.`,
          invalidLengthAccountNumber: `Length from 5 digits to 18 digits.`,
          requiredRoutingNumber: `Routing number can't be empty.`,
          invalidRoutingNumber: 'Invalid routing number.',
          invalidCVV: 'CVV should be 3 digits or 4 digits for Amex.',
          requiredCVV: `CVV can't be empty.`,
          requiredExpirationDate: `Expiration date can't be empty.`,
          invalidZipCode:
            'Please enter a valid zip code format (e.g. 12345 or 12345-6789)',
          blackListed: 'Profile name blacklisted.',
          taken: 'Profile name is taken.',
          requiredBirthday: 'Birthday is required.',
          requiredAddress: 'Address is required.',
          usernameNotValid: `Profile name should only contain letters and numbers.`,
          usernameBlackList: 'Profile name blacklisted.',
          duplicateUsername: 'Profile name is already in use.',
          serverError: (error: string) => error,
        },
      },
      controlErrorComponent: FormControlErrorComponent,
    }),
    FormFieldAddressComponent,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    errorTailorImports,
    NgxMaskPipe,
    NgxMaskDirective,
    TranslateModule,
    ...components,
  ],
})
export class SharedUiFormModule {}
